import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  color: theme.palette.secondary.main,
}));

export default StyledBox;
